module.exports = __webpack_public_path__ + "background3.jpg?41dcc9e446de8baadb64af39636734df";